<template>
  <MasterDetail
    ref="masterDetail"
    :canDelete="false"
    :cols="cols"
    :confirmDeleteMessage="confirmDeleteMessage"
    :hasExportCSV="false"
    :hasExportXLSX="false"
    :opts="opts"
    :customResource="customResource"
    serverPagination
  ></MasterDetail>
</template>

<script>
import MasterDetail from "@/components/master-detail.vue";
import { mapGetters } from "vuex";
import businessUnitsDivisaoService from "@/api/ativacaoped/business-units-divisao.service";
import businessUnitsService from "@/api/ativacaoped/business-units.service";
import { createServiceResource } from "@/api/ativacaoped/resource-adapter";

export default {
  components: {
    MasterDetail
  },
  data() {
    return {
      opts: {
        divisoes: []
      }
    };
  },
  computed: {
    ...mapGetters(["clientId"]),
    cols() {
      return [
        {
          key: "divisao_id",
          name: "Divisão",
          type: this.$fieldTypes.AUTOCOMPLETE,
          rel: { to: "divisoes", key: "id", name: "nome" },
          rules: [{ rule: "required" }]
        },
        {
          key: "nome",
          name: "Business Unit",
          type: this.$fieldTypes.TEXT,
          rules: [{ rule: "required" }, { rule: "max", params: { size: 255 } }]
        }
      ];
    },
    /**
     * Resource service-backed consumido pelo `MasterDetail` (`get` na grid e
     * `save` no formulário). `delete` está desabilitado na tela
     * (`:canDelete="false"`), então não é exposto aqui.
     * Substitui o `:resourceUrl`, que usava o `apiResource` inline do mixin.
     *
     * @returns {Object} Resource no contrato do `apiResource`
     */
    customResource() {
      // Ver nota em `divisoes.vue`: ler `clientId` aqui mantém o reload da grid
      // pelo watcher de `customResource` do `MasterDetail`.
      const clientId = this.clientId;

      return createServiceResource({
        notify: this.notify,
        get: ({ query }) => businessUnitsService.getBusinessUnits(clientId, query),
        save: (data, id) =>
          id
            ? businessUnitsService.putBusinessUnit(clientId, id, data)
            : businessUnitsService.postBusinessUnit(clientId, data)
      });
    }
  },
  created() {
    if (this.clientId === 0) {
      this.goToHome();
    } else {
      this.getDivisoes();
    }
  },
  watch: {
    clientId(value) {
      if (value === 0) {
        this.goToHome();
        return;
      }

      // `opts.divisoes` é carregado no `created`: na troca de empresa precisa
      // ser recarregado para o cliente novo.
      this.getDivisoes();
    }
  },
  methods: {
    confirmDeleteMessage({ divisao, nome }) {
      return `Deseja excluir o registro ${nome} — ${divisao}?`;
    },
    async getDivisoes() {
      try {
        const response = await businessUnitsDivisaoService.getSelecaoBusinessUnitsDivisao(
          this.clientId
        );
        this.opts.divisoes = response;
      } catch (error) {
        this.opts.divisoes = [];
        this.notify(error);
      }
    },
    goToHome() {
      this.notify({
        error: 'Não é possível acessar o módulo de Ativação P&D sem uma empresa selecionada.',
      });
      this.$router.push({ name: "homepage" });
    },
  }
};
</script>
